import { MutationTree } from 'vuex';
import { APP } from '../mutation_types';
import { IAPPSTATE, IOpenTag } from '../state.d';
import actions from '../actions/app';

const defaultTag: Array<IOpenTag> = [
  {
    closable: false,
    name: '首页',
    active: true,
    path: 'dashboard',
  },
];

const state: IAPPSTATE = {
  menuStatus: true, // true: open false: close
  openTags: JSON.parse(window.sessionStorage.getItem('openTags') as string) || defaultTag,
};
/* eslint-disable no-param-reassign */
const mutations: MutationTree<IAPPSTATE> = {
  [APP.SET_APP_MENU_STATUS]: (s) => {
    s.menuStatus = !s.menuStatus;
  },
  [APP.SET_APP_OPEN_TAGS]: (s, list: Array<IOpenTag>) => {
    s.openTags = list;
    window.sessionStorage.setItem('openTags', JSON.stringify(list));
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
